/**
 * Bannière permanente du mode assistance (A1.2).
 * Injection minimale — pas de refonte Layout / sidebar.
 */

export default function AssistanceBanner({ commercantLabel, expiresAt, onExit }) {
  if (!commercantLabel) return null;

  let expiresLabel = null;
  if (expiresAt) {
    const ts = Date.parse(expiresAt);
    if (!Number.isNaN(ts)) {
      expiresLabel = new Date(ts).toLocaleTimeString('fr-FR', {
        hour: '2-digit',
        minute: '2-digit',
      });
    }
  }

  return (
    <div
      role="status"
      className="sticky top-0 z-[90] w-full bg-amber-500 px-3 py-2 text-amber-950 shadow"
    >
      <div className="mx-auto flex max-w-[1800px] flex-wrap items-center justify-between gap-2">
        <p className="text-sm font-semibold">
          Mode assistance — {commercantLabel}
          {expiresLabel ? (
            <span className="ml-2 font-normal opacity-90">
              (expire à {expiresLabel})
            </span>
          ) : null}
        </p>
        <button
          type="button"
          onClick={onExit}
          className="rounded-md bg-amber-950/10 px-3 py-1 text-sm font-medium hover:bg-amber-950/20"
        >
          Quitter l&apos;assistance
        </button>
      </div>
    </div>
  );
}
